export const Permissions = {
  dashboard: {
    read: "dashboard:read",
  },
  facebook: {
    read: "facebook:read",
    manage: "facebook:manage",
  },
  feeds: {
    read: "feeds:read",
    manage: "feeds:manage",
  },
  products: {
    read: "products:read",
    manage: "products:manage",
  },
  orders: {
    read: "orders:read",
    manage: "orders:manage",
  },
  live: {
    read: "live:read",
    manage: "live:manage",
  },
  messages: {
    read: "messages:read",
    manage: "messages:manage",
  },
  webhooks: {
    read: "webhooks:read",
  },
  users: {
    create: "users:create",
    read: "users:read",
    update: "users:update",
    delete: "users:delete",
    ban: "users:ban",
  },
  audit: {
    read: "audit:read",
  },
} as const;

export const ALL_PERMISSIONS = Object.entries(Permissions).flatMap(
  ([resource, actions]) =>
    Object.entries(actions).map(([action, id]) => ({ id, resource, action })),
);

export type PermissionId = (typeof ALL_PERMISSIONS)[number]["id"];

// Human-friendly labels for rendering in UI
export const RESOURCE_LABELS: Record<string, string> = {
  dashboard: "ແຜງຄວບຄຸມ",
  facebook: "Facebook",
  feeds: "ໂພສ / ຟີດ",
  products: "ສິນຄ້າ CF",
  orders: "ອໍເດີ CF",
  live: "Live",
  messages: "ຂໍ້ຄວາມ",
  webhooks: "Webhook",
  users: "ຜູ້ໃຊ້",
  audit: "ບັນທຶກການກວດກາ",
};

export const ACTION_LABELS: Record<string, string> = {
  create: "ສ້າງ",
  read: "ເບິ່ງ",
  update: "ແກ້ໄຂ",
  delete: "ລຶບ",
  ban: "ລະງັບ",
  manage: "ຈັດການ",
  all: "ທັງໝົດ",
};

export function getResourceLabel(resource: string): string {
  return RESOURCE_LABELS[resource] ?? resource;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}

export function getPermissionLabel(id: PermissionId): string {
  const [resource, action] = (id as string).split(":");
  return `${getActionLabel(action ?? "")} ${getResourceLabel(resource ?? "")}`;
}

export function getPermissionLabels(ids: PermissionId[]): string[] {
  return ids.map((id) => getPermissionLabel(id));
}
